import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {PoslovniUgovorDocument} from "../ugovori/PoslovniUgovorDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {UgovorORaduDocument} from "./UgovorORaduDocument";
import {RaskidUgovoraORaduDocument} from "./RaskidUgovoraORaduDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, zaposleni, sektor
// opciono: opis, lista priloga, pozicija, datum prestanka radnog odnosa

export const raskidUgovoraORaduDocumentFields: IntercateKeysMap<RaskidUgovoraORaduDocument, EntityField<RaskidUgovoraORaduDocument>> = {
	...baseDocumentFields,
	employeeId: {
		name: "employeeId", dataType: EntityFieldDataType._reference, label: "Zaposleni",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Employees
		},
		validator: { required: true },
		sortable: true
	},
	positionId: {
		name: "positionId", dataType: EntityFieldDataType._reference, label: "Pozicija",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Positions
		},
		validator: { required: false },
		sortable: true
	},
	cancellationDate: {
		name: "cancellationDate", dataType: EntityFieldDataType._date, label: "Datum raskida",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.employeeId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<RaskidUgovoraORaduDocument>> = [
	raskidUgovoraORaduDocumentFields.indexingNumber,
	raskidUgovoraORaduDocumentFields.indexingDate,
	raskidUgovoraORaduDocumentFields.documentNumber,
	raskidUgovoraORaduDocumentFields.documentDate,
	raskidUgovoraORaduDocumentFields.assignedTo,
	raskidUgovoraORaduDocumentFields.sectorId,
	raskidUgovoraORaduDocumentFields.positionId,
	raskidUgovoraORaduDocumentFields.employeeId,
	raskidUgovoraORaduDocumentFields.cancellationDate,
	raskidUgovoraORaduDocumentFields.tags,
	raskidUgovoraORaduDocumentFields.description,
	raskidUgovoraORaduDocumentFields.parentId
]

export const raskidUgovoraORaduDocumentFieldsDescriptor: EntityFieldsDescriptor<RaskidUgovoraORaduDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
